import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetPageMutation implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.setPage]: (localState: SearchState, page: number) => {
      localState.page = page;
    }
  };
}
